export function isIdealPostcodesFeatureEnabled(): boolean {
  return (
    import.meta.env.VITE_IDEAL_POSTCODES_ENABLED === 'true' &&
    Boolean(import.meta.env.VITE_IDEAL_POSTCODES_API_KEY)
  );
}
